import React, { createContext } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import PostStore from "./store/PostStore";
import UserStore from "./store/UserStore";
import ClinicStore from "./store/ClinicStore";
import FeaturesStore from "./store/FeaturesStore";
import SocketStore from "./store/SocketStore";
import ChatStatsStore from "./store/ChatStatsStore";
import ReviewRequestsStatsStore from "./store/ReviewRequestsStatsStore";
import './globalStyles.css';

export const Context = createContext(null);

const root = ReactDOM.createRoot(document.getElementById("root"));

const clinicStore = new ClinicStore();
const userStore = new UserStore(clinicStore);
const featuresStore = new FeaturesStore();
const socketStore = new SocketStore();
const chatStatsStore = new ChatStatsStore();
const reviewRequestsStatsStore = new ReviewRequestsStatsStore();

root.render(
  <Context.Provider
    value={{
      user: userStore,
      posts: new PostStore(),
      clinic: clinicStore,
      features: featuresStore,
      socket: socketStore,
      chatStats: chatStatsStore,
      reviewRequestsStats: reviewRequestsStatsStore,
    }}
  >
    <App />
  </Context.Provider>
);
